module.exports = __webpack_public_path__ + "4693b7f0dee59b86054a1c3be5f6d900.png";